const SocialMedia = ({ imageUrl, linkUrl, iconWidth, iconHeight, ariaLabel }) => {
    return (
        <a href={linkUrl} target="_blank" rel="noreferrer noopener" aria-label={ariaLabel} >
            <img
                src={imageUrl}
                alt=""
                className="social-media-iconSize"
                width={21}
                height={21}
                style={{ width: iconWidth, height: iconHeight}}
                loading="lazy"
                decoding="async"
            />
        </a>
    )
};

export default SocialMedia;
